import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
export function BreakdownBars({ title, description, entries, limit = 6, empty, className, }) {
    const total = React.useMemo(() => entries.reduce((acc, e) => acc + e.value, 0), [entries]);
    const isEmpty = entries.length === 0 || total === 0;
    const sorted = React.useMemo(() => [...entries].sort((a, b) => b.value - a.value), [entries]);
    const visible = sorted.slice(0, limit);
    const rest = sorted.slice(limit);
    const restTotal = rest.reduce((acc, e) => acc + e.value, 0);
    return (<Card className={cn('border-border/60', className)}>
            <CardHeader className="gap-1 pb-3">
                <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
                {description ? <CardDescription className="text-xs">{description}</CardDescription> : null}
            </CardHeader>
            <CardContent className="pt-0">
                {isEmpty ? (<div className="flex h-32 items-center justify-center rounded-md bg-muted/20 text-sm text-muted-foreground">
                        {empty ?? 'No data yet'}
                    </div>) : (<ul className="space-y-2.5">
                        {visible.map((entry) => {
                const pct = total > 0 ? Math.round((entry.value / total) * 100) : 0;
                return (<li key={entry.key} className="space-y-1.5">
                                    <div className="flex items-center justify-between gap-3 text-sm">
                                        <div className="flex min-w-0 items-center gap-2">
                                            <span className={cn('h-2 w-2 shrink-0 rounded-full bg-foreground/40', entry.barClassName)}/>
                                            <span className="truncate text-foreground">{entry.label}</span>
                                        </div>
                                        <div className="flex items-baseline gap-2">
                                            <span className="font-medium tabular-nums text-foreground">
                                                {entry.value.toLocaleString()}
                                            </span>
                                            <span className="w-9 text-right text-xs tabular-nums text-muted-foreground">
                                                {pct}%
                                            </span>
                                        </div>
                                    </div>
                                    <div className="h-1.5 overflow-hidden rounded-full bg-muted/50">
                                        <div className={cn('h-full rounded-full bg-foreground/40 transition-[width]', entry.barClassName)} style={{ width: `${Math.max(2, pct)}%` }}/>
                                    </div>
                                </li>);
            })}
                        {rest.length > 0 ? (<li className="pt-1 text-xs text-muted-foreground">
                                +{rest.length} more · {restTotal.toLocaleString()} (
                                {total > 0 ? Math.round((restTotal / total) * 100) : 0}%)
                            </li>) : null}
                    </ul>)}
            </CardContent>
        </Card>);
}
